// Module
var code = `<div class="circle-chart"> <component-donut-chart></component-donut-chart> </div>`;
// Exports
export default code;